import { uiText } from '../../i18n/uiText';
import React, { useState } from 'react';
import { commentsApi, getApiErrorMessage } from '../../api';
import { useAuth } from '../../store/AuthContext';
import useDraftBuffer from '../../hooks/useDraftBuffer';
import FormDraftNotice from '../common/FormDraftNotice';

export default function QuestionDiscussion({ auditId, question, comments, answers = [], disabled, onSent }) {
  const { user } = useAuth();
  const extraId = question.extra_question_id || null;
  const questionId = extraId ? null : (question.question_id || question.id);
  const buffer = useDraftBuffer(user?.id, `${auditId}:${extraId ? 'e' + extraId : 'q' + questionId}`, 'question-discussion');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const items = comments.filter(c => extraId ? c.extra_question_id === extraId : c.question_id === questionId);
  const responses = answers.filter(a => !a.is_draft && (extraId ? a.extra_question_id === extraId : a.question_id === questionId));
  const send = async () => {
    if (sending || disabled || buffer.recovery || !buffer.values.text?.trim()) return;
    const snapshot = buffer.snapshot();
    setSending(true); setError('');
    try {
      await commentsApi.create({ audit_id: auditId, question_id: questionId, extra_question_id: extraId, text: buffer.values.text });
      buffer.acknowledge(snapshot, { committed: true });
      if (!buffer.count) buffer.hydrate({ text: '' });
      await onSent();
    } catch (err) { setError(getApiErrorMessage(err)); }
    finally { setSending(false); }
  };
  return <details style={{ padding: 12, border: '1px solid var(--border-color, #475569)', borderRadius: 10, marginTop: 12 }}>
    <summary>{uiText("Обсуждение ответа (")}{items.length})</summary>
    <div style={{ display: 'grid', gap: 12, paddingTop: 12 }}>
      {responses.map(answer => <div key={answer.id}><strong>{answer.answered_by === 'customer' ? uiText("Ответ проверяемого") : uiText("Решение аудитора")}</strong>
        <p style={{ margin: '4px 0' }}>{answer.value_bool === true ? uiText("Да") : answer.value_bool === false ? uiText("Нет") : (answer.value_text || (answer.value_number ?? uiText("Ответ отменён / не заполнен")))}</p>
        {answer.comment_text && <p style={{ whiteSpace: 'pre-wrap', margin: '4px 0' }}>{answer.comment_text}</p>}
      </div>)}
      {items.map(item => <div key={item.id}><strong>{item.author?.full_name || uiText("Пользователь")}</strong><p style={{ whiteSpace: 'pre-wrap', margin: '4px 0' }}>{item.text}</p></div>)}
      {!disabled && <><FormDraftNotice buffer={buffer} label={uiText("Сообщение по вопросу")} disabled={sending} />
        <textarea className="ap-control" rows={2} maxLength={5000} aria-label={uiText("Сообщение по ответу")} value={buffer.values.text || ''} disabled={sending || !!buffer.recovery} onChange={event => buffer.edit('text', event.target.value)} />
        <div><button type="button" className="btn btn-outline" disabled={sending || !!buffer.recovery || !buffer.values.text?.trim()} onClick={send}>{sending ? uiText("Отправка…") : uiText("Отправить сообщение")}</button></div></>}
      {error && <div role="alert">{error}</div>}
    </div>
  </details>;
}
